import { render, staticRenderFns } from "./singleOption.vue?vue&type=template&id=45785c6c&scoped=true&"
import script from "./singleOption.vue?vue&type=script&lang=js&"
export * from "./singleOption.vue?vue&type=script&lang=js&"
import style0 from "./singleOption.vue?vue&type=style&index=0&id=45785c6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45785c6c",
  null
  
)

export default component.exports